<style src="./ContextDynamicVunitFilter.scss" lang="scss"></style>
<template>
  <section class="context-dynamic-vunit-filter">
    <form @submit.prevent="openModalConfirm" class="rowsection">
      <span class="filtertitle">Aplicar Valores</span>
      <div class="filters">
        <select
          class="cp1-small-select field marginright"
          v-model="form.fieldName">
          <option
            v-for="(filterType, filterTypeIdx) in lists.fields"
            :key="filterTypeIdx"
            :value="filterType">{{ filterType }}</option>
        </select>
        <select
          class="cp1-small-select operator marginright"
          v-model="form.operator">
          <option
            v-for="(filterType, filterTypeIdx) in lists.operators"
            :key="filterTypeIdx"
            :value="filterType">{{ filterType }}</option>
        </select>
        <input
          type="text"
          v-model="form.value"
          placeholder="10"
          class="cp1-small-textbox inputoperand marginright" />
        <select
          class="cp1-small-select valuetype marginright"
          v-model="form.valueType">
          <option
            v-for="(filterType, filterTypeIdx) in lists.valueTypes"
            :key="filterTypeIdx"
            :value="filterType">{{ filterType }}</option>
        </select>
        <button
          class="cp1-small-button cp1-button__success filterbutton">
          Aplicar
        </button>
      </div>
    </form>

    <modal
      transition="nice-modal-fade"
      name="modalConfirmAddSale"
      width="500px"
      height="auto">
      <aside class="modal-confirm">
        <icon-danger class="illustration" />

        <div class="description">
          <p class="info">
            Essa ação irá atualizar a lista de <strong>Valor Unitário</strong>.
          </p>
          <p class="info">
            Tem certeza que deseja continuar?
          </p>
        </div>

        <section class="cmdcancel">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>
        </section>
        <form
          @submit.prevent="applyValue"
          class="cmdapply">

          <button-submit
            label="Sim, pode alterar os valores"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'
import CalculateDynamicSaleFilter from '../../helpers/CalculateDynamicSaleFilter'

export default {
  name: 'ContextDynamicVunitFilter',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  props: {
    columnId: null
  },
  data: () => ({
    form: {
      fieldName: 'ESTIMADO',
      operator: '-',
      value: '10',
      valueType: '%'
    },
    lists: {
      fields: [
        'CUSTO',
        'ESTIMADO',
        'CMED',
        'MÁXIMO'
      ],
      operators: [
        '+',
        '-',
        '±'
      ],
      valueTypes: [
        '%',
        'R$',
        '% V',
        'R$ V'
      ]
    },
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  mounted () {},
  methods: {
    cancelApply () {
      this.$modal.hide('modalConfirmAddSale')
    },
    openModalConfirm () {
      this.$modal.show('modalConfirmAddSale')
    },
    async applyValue () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      this.commands.submitState = 'WAIT'

      // Get Total Column ID
      const columnUnitIndex = this.$store.getters['ItemPricing/GET_DYNAMIC_COLUMNS'].findIndex(i => i.columnId === this.columnId)
      const columnUnit = this.columnId
      const columnTotal = this.$store.getters['ItemPricing/GET_DYNAMIC_COLUMNS'][columnUnitIndex + 1].columnId
      const columnPerc = this.$store.getters['ItemPricing/GET_DYNAMIC_COLUMNS'][columnUnitIndex + 2].columnId

      const selectedItems = this.$store.getters['ItemPricing/FILTERED_LIST']
      const calculateColumns = CalculateDynamicSaleFilter({ columnUnit, columnTotal, columnPerc })
      const calculateMath = calculateColumns({ ...this.form })
      const items = selectedItems.map(i => calculateMath(i)).flat()

      const payload = {
        items
      }
      try {
        await this.$store.dispatch('ItemPricing/UPDATE_DYNAMIC_LIST', payload)
        this.$store.commit('ItemPricing/UPDATE_DYNAMIC_UNIT_COLUMN', payload)
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalConfirmAddSale')
        this.$emit('close')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-dynamic-vunit-filter/ContextDynamicVunitFilter.vue